import UpdateCognitiveTestsBlockedModal, {
  IUpdateCognitiveTestsBlockedModal,
} from 'components/feature/UpdateCognitiveTestsBlocked/UpdateCognitiveTestsBlockedModal';
import ConfirmationModal, {
  TConfirmationModal,
} from 'components/organisms/ConfirmationModal/ConfirmationModal';
import StyledConfirmationModal from 'components/organisms/StyledConfirmationModal';
import { ModalTypes } from 'enums/modalTypes';
import { GET_MODALS_QUERY } from 'graphql/modals';
import {
  IGetModalsQueryResponse,
  StyledConfirmationModalProps,
  TAddNewCompanySignatureModalProps,
  TAddNewUserModalProps,
  TAddNewUserRoleModalProps,
  TAddTraitModal,
  TAddWidgetModalProps,
  TAddWidgetOptionModalProps,
  TCandidateInfoModal,
  TConfigModalProps,
  TEditTraitModal,
  TEditUserModalProps,
  TMitigateCircumstanceModal,
  TReportsModalProps,
  TStageIndirectInvitationModal,
  TStaticContentFiltersModal,
  TTextFormFieldModal,
  TWarningModalProps,
} from 'interfaces/modal';
import { FC } from 'react';
import { DownloadSoftSkillContentModal } from 'views/ModalView/DownloadSoftSkillContentModal/DownloadSoftSkillContentModal';
import UploadInterviewQuestionsCSVModal, {
  IUploadInterviewQuestionsCSVModal,
} from 'views/ModalView/UploadInterviewQuestionsCSVModal/UploadInterviewQuestionsCSVModal';
import UploadSoftSkillsContentCSVModal from 'views/ModalView/UploadSoftSkillsContentCSVModal/UploadSoftSkillsContentCSVModal';
import UploadTraitsContentCSVModal from 'views/ModalView/UploadTraitsContentCSVModal/UploadTraitsContentCSVModal';
import { useQuery } from '@apollo/client';
import EditDeiActionModal, {
  IEditDeiActionModal,
} from '../Project/components/Stages/StageActions/EditDeiActionModal';
import AddNewCompanySignatureModal from './AddNewCompanySignatureModal/AddNewCompanySignatureModal';
import AddNewUserModal from './AddNewUserModal/AddNewUserModal';
import AddNewUserRoleModal from './AddNewUserRoleModal/AddNewUserRoleModal';
import AddWidgetModal from './AddWidgetModal/AddWidgetModal';
import AddWidgetOptionModal from './AddWidgetOptionModal/AddWidgetOptionModal';
import BehaviourContentModal, {
  IBehaviourContentModal,
} from './BehaviourContentModal/BehaviourContentModal';
import CandidateEditInfoFieldModal from './CandidateInfoFieldModal/CandidateInfoFieldModal';
import CompanyEmployeeModal, {
  ICompanyEmployeeModal,
} from './CompanyEmployeeModal';
import DeleteAssessmentModal, {
  IDeleteAssessmentProps,
} from './DeleteAssessmentModal/DeleteAssessmentModal';
import EditHRManagerEmployeeIDModal, {
  IEditHRManagerEmployeeIDModal,
} from './EditHRManagerEmployeeIDModal';
import EditUserModal from './EditUserModal/EditUserModal';
import MitigateCircumstanceModal from './MitigateCircumstanceModal/MitigateCircumstanceModal';
import { renderModalObject } from './ModalView.constants';
import NotificationModal, { NotificationModalProps } from './NotificationModal';
import ReportsModal from './ReportsModal/ReportsModal';
import StageIndirectInvitationModal from './StageIndirectInvitationModal';
import WarningModal from './WarningModal/WarningModal';
import WidgetConfigModal from './WidgetConfigModal/WidgetConfigModal';

interface IModalView {}

const ModalView: FC<IModalView> = () => {
  const modalsQueryResponse =
    useQuery<IGetModalsQueryResponse>(GET_MODALS_QUERY);

  if (modalsQueryResponse.data?.modals.length) {
    const { modals } = modalsQueryResponse.data;

    return (
      <>
        {modals.map(modal => {
          if (modal.modalType === ModalTypes.CANDIDATE_INFO_FIELD_MODAL) {
            return (
              <CandidateEditInfoFieldModal
                key={modal.modalType}
                {...(modal.modalProps as TCandidateInfoModal)}
              />
            );
          }

          if (modal.modalType === ModalTypes.ADD_TRAIT_MODAL) {
            const ModalComponent = renderModalObject[modal.modalType];
            return (
              <ModalComponent
                key={modal.modalType}
                {...(modal.modalProps as TAddTraitModal)}
              />
            );
          }

          if (modal.modalType === ModalTypes.EDIT_TRAIT_MODAL) {
            const ModalComponent = renderModalObject[modal.modalType];
            return (
              <ModalComponent
                key={modal.modalType}
                {...(modal.modalProps as TEditTraitModal)}
              />
            );
          }

          if (modal.modalType === ModalTypes.STATIC_CONTENT_FILTERS_MODAL) {
            const ModalComponent = renderModalObject[modal.modalType];
            return (
              <ModalComponent
                key={modal.modalType}
                {...(modal.modalProps as TStaticContentFiltersModal)}
              />
            );
          }

          if (modal.modalType === ModalTypes.TEXT_FIELD_MODAL) {
            const ModalComponent = renderModalObject[modal.modalType];
            return (
              <ModalComponent
                key={modal.modalType}
                {...(modal.modalProps as TTextFormFieldModal)}
              />
            );
          }

          if (modal.modalType === ModalTypes.WARNING_MODAL) {
            return (
              <WarningModal
                key={modal.modalType}
                {...(modal.modalProps as TWarningModalProps)}
              />
            );
          }

          if (modal.modalType === ModalTypes.REPORTS_PAGE_MODAL) {
            return (
              <ReportsModal
                key={modal.modalType}
                {...(modal.modalProps as TReportsModalProps)}
              />
            );
          }

          if (modal.modalType === ModalTypes.ADD_WIDGET_OPTION_MODAL) {
            return (
              <AddWidgetOptionModal
                key={modal.modalType}
                {...(modal.modalProps as TAddWidgetOptionModalProps)}
              />
            );
          }

          if (modal.modalType === ModalTypes.ADD_WIDGET_MODAL) {
            return (
              <AddWidgetModal
                key={modal.modalType}
                {...(modal.modalProps as TAddWidgetModalProps)}
              />
            );
          }

          if (modal.modalType === ModalTypes.WIDGET_CONFIG_MODAL) {
            return (
              <WidgetConfigModal
                key={modal.modalType}
                {...(modal.modalProps as TConfigModalProps)}
              />
            );
          }

          if (modal.modalType === ModalTypes.ADD_NEW_USER_ROLE_MODAL) {
            return (
              <AddNewUserRoleModal
                key={modal.modalType}
                {...(modal.modalProps as TAddNewUserRoleModalProps)}
              />
            );
          }
          if (modal.modalType === ModalTypes.ADD_NEW_USER_MODAL) {
            return (
              <AddNewUserModal
                key={modal.modalType}
                {...(modal.modalProps as TAddNewUserModalProps)}
              />
            );
          }
          if (modal.modalType === ModalTypes.EDIT_USER_MODAL) {
            return (
              <EditUserModal
                key={modal.modalType}
                {...(modal.modalProps as TEditUserModalProps)}
              />
            );
          }

          if (modal.modalType === ModalTypes.CONFIRMATION_MODAL) {
            return (
              <ConfirmationModal
                key={modal.modalType}
                {...(modal.modalProps as TConfirmationModal)}
              />
            );
          }

          if (modal.modalType === ModalTypes.ADD_COMPANY_SIGNATURE_MODAL) {
            return (
              <AddNewCompanySignatureModal
                key={modal.modalType}
                {...(modal.modalProps as TAddNewCompanySignatureModalProps)}
              />
            );
          }

          if (modal.modalType === ModalTypes.STAGE_INDIRECT_INVITATION_MODAL) {
            return (
              <StageIndirectInvitationModal
                key={modal.modalType}
                {...(modal.modalProps as TStageIndirectInvitationModal)}
              />
            );
          }

          if (modal.modalType === ModalTypes.MITIGATE_CIRCUMSTANCE_MODAL) {
            return (
              <MitigateCircumstanceModal
                key={modal.modalType}
                {...(modal.modalProps as TMitigateCircumstanceModal)}
              />
            );
          }
          if (modal.modalType === ModalTypes.STYLED_CONFIRMATION_MODAL) {
            return (
              <StyledConfirmationModal
                key={modal.modalType}
                {...(modal.modalProps as StyledConfirmationModalProps)}
              />
            );
          }
          if (modal.modalType === ModalTypes.NOTIFICATION_MODAL) {
            return (
              <NotificationModal
                key={modal.modalType}
                {...(modal.modalProps as NotificationModalProps)}
              />
            );
          }
          if (modal.modalType === ModalTypes.COMPANY_EMPLOYEE_MODAL) {
            return (
              <CompanyEmployeeModal
                key={modal.modalType}
                {...(modal.modalProps as ICompanyEmployeeModal)}
              />
            );
          }
          if (
            modal.modalType === ModalTypes.EDIT_HR_MANAGER_EMPLOYEE_ID_MODAL
          ) {
            return (
              <EditHRManagerEmployeeIDModal
                key={modal.modalType}
                {...(modal.modalProps as IEditHRManagerEmployeeIDModal)}
              />
            );
          }
          if (modal.modalType === ModalTypes.BEHAVIOUR_CONTENT_MODAL) {
            return (
              <BehaviourContentModal
                key={modal.modalType}
                {...(modal.modalProps as IBehaviourContentModal)}
              />
            );
          }
          if (modal.modalType === ModalTypes.DELETE_ASSESSMENT_MODAL) {
            return (
              <DeleteAssessmentModal
                key={modal.modalType}
                {...(modal.modalProps as IDeleteAssessmentProps)}
              />
            );
          }
          if (modal.modalType === ModalTypes.EDIT_DEI_ACTION) {
            return (
              <EditDeiActionModal
                key={modal.modalType}
                {...(modal.modalProps as IEditDeiActionModal)}
              />
            );
          }
          if (
            modal.modalType === ModalTypes.UPLOAD_INTERVIEW_QUESTION_CSV_MODAL
          ) {
            return (
              <UploadInterviewQuestionsCSVModal
                key={modal.modalType}
                {...(modal.modalProps as IUploadInterviewQuestionsCSVModal)}
              />
            );
          }
          if (modal.modalType === ModalTypes.UPDATE_COGNITIVE_TESTS_BLOCKED) {
            return (
              <UpdateCognitiveTestsBlockedModal
                key={modal.modalType}
                {...(modal.modalProps as IUpdateCognitiveTestsBlockedModal)}
              />
            );
          }
          if (
            modal.modalType === ModalTypes.UPLOAD_SOFT_SKILLS_CONTENT_CSV_MODAL
          ) {
            return <UploadSoftSkillsContentCSVModal key={modal.modalType} />;
          }
          if (
            modal.modalType ===
            ModalTypes.DOWNLOAD_SOFT_SKILLS_CONTENT_CSV_MODAL
          ) {
            return <DownloadSoftSkillContentModal key={modal.modalType} />;
          }
          if (modal.modalType === ModalTypes.UPLOAD_TRAIT_CONTENT_CSV_MODAL) {
            return <UploadTraitsContentCSVModal key={modal.modalType} />;
          }
          return null;
        })}
      </>
    );
  }

  return null;
};

export default ModalView;
